"use client";

import React from "react";

export interface AdminFormSectionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  description?: string;
  compact?: boolean;
}

export function AdminFormSection({
  title,
  description,
  children,
  compact = false,
}: AdminFormSectionProps) {
  return (
    <div
      className={
        compact
          ? "pt-2 mb-2 space-y-1.5"
          : "pt-3 mb-3 space-y-3"
      }
    >
      <div>
        <h3
          className={
            compact
              ? "text-xs uppercase tracking-wide text-primary pb-1.5"
              : "text-xs uppercase tracking-wide text-primary pb-3"
          }
        >
          {title}
        </h3>
        {description ? (
          <p className="text-xs text-muted-foreground -mt-2 pb-2">
            {description}
          </p>
        ) : null}
      </div>
      {children}
    </div>
  );
}